import { CheckIcon } from '@heroicons/react/20/solid';
import { UseUserAuth } from './context/UseAuthContext';
import { useNavigate } from 'react-router-dom';
const tiers = [
  
  {
    name: 'Digital Storybook',//'Bundle',
    id: '1',
    href: '#tier-digital',
    //price: '$5.00',
    price: '$3.00',
    originalPrice: '$5.00',
    description: 'Greater Creative Control Over Your Story', //Greater Creative Freedom
    features: [
      "Create a custom children's e-book in a few minutes",
      'A complete 20-page story with 10 paragraphs and 10 illustrations',
      'Up to 20 image customizations (edit image descriptions or regenerate image) per story', //'Try different image descriptions to explore new visual styles',
      'Edit story text and story title to your liking',
      'Full creative control over your storybook',
      'Download as PDF or read online',
      'One-click download of Instagram-ready slides for sharing'
      //'Cancel anytime'
    ],
  },
  {
    name: 'Printed Storybook',
    id: '2',
    href: '#tier-print',
    price: '$20.00',
    originalPrice: '$25.00',
    description: 'Beautiful Physical Keepsake - Launch Special 20% Off!',
    features: [
      'High-quality paperback printing',
      'Beautiful keepsake for your family',
      'Hardcover coming soon',
      'Perfect gift',
      'Treasure your story forever',
      'Shipping calculated at checkout',
      'Available after creating digital story'
    ],
  }
  
]

export default function Pricing() {
  const {  user } = UseUserAuth();
  //console.log("create user", user);
  const navigate = useNavigate();

  function handleCheckout(e, productId) {
    e.preventDefault();
    if (user){
     console.log("productid",productId);
     console.log(typeof productId);
    navigate(`/cart`, { state: { productId : productId } }); }
    else{
      navigate('/login')
    } // Pass product ID as state
  };
  return (
    <div className="isolate overflow-hidden bg-gray-900">
      <div className="mx-auto max-w-5xl px-6 pb-96 pt-10 text-center sm:pt-30 lg:px-8">
        <div className="mx-auto max-w-3xl">
          <h2 className="text-base font-semibold leading-7 text-indigo-400">Pricing</h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
          Stories Delivered Digitally & Physically
          {/*Digital First, Print When Perfect
          Invest in your child's reading adventure  */}
           
          </p>
        </div>
        <div className="relative mt-6">
          <p className="mx-auto max-w-xl text-lg leading-8 text-white/60">
          First digital story free, then choose your perfect plan          </p>
          {/* Sale Badge */}
          <div className="mx-auto mt-4 inline-flex items-center rounded-full bg-indigo-600 px-4 py-2 text-sm font-semibold text-white">
          🌟 40% Off Digital + Print Launch Special 20% Off - Limited Time!
          </div>
           <svg
            viewBox="0 0 1208 1024"
            className="absolute -top-10 left-1/2 -z-10 h-[64rem] -translate-x-1/2 [mask-image:radial-gradient(closest-side,white,transparent)] sm:-top-12 md:-top-20 lg:-top-12 xl:top-0"
          >
         
          </svg>
        </div>
      </div>
      <div className="flow-root bg-white pb-8 sm:pb-12">
        <div className="-mt-80">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mx-auto grid max-w-md grid-cols-1 gap-8 lg:max-w-4xl lg:grid-cols-2">
              {tiers.map((tier) => (
                <div
                  key={tier.id}
                  className="flex flex-col justify-between rounded-3xl bg-white p-8 shadow-xl ring-1 ring-gray-900/10 sm:p-10"
                >
                  <div>
                    <h3 id={tier.id} className="text-base font-semibold leading-7 text-indigo-600">
                      {tier.name}
                    </h3>
                    <div className="mt-4 flex items-baseline gap-x-2">
                  
                      <span className="text-3xl font-bold tracking-tight text-gray-900">{tier.price}</span>
                      <span className="text-xl font-medium text-gray-500 line-through">{tier.originalPrice}</span>                     
                     {/*} {tier.priceMonthly === '$34.99' && <span className="text-base font-semibold leading-7 text-gray-600">/month</span>} */}
                    </div>
                    <p className="mt-3 text-base leading-7 text-gray-600">{tier.description}</p>
                    <ul role="list" className="mt-6 space-y-4 text-sm leading-6 text-gray-600">
                      {tier.features.map((feature) => (
                        <li key={feature} className="flex gap-x-3">
                          <CheckIcon className="h-6 w-5 flex-none text-indigo-600" aria-hidden="true" />
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
            {/*}      <button className="mt-6 block rounded-md bg-indigo-600 px-3.5 py-2 text-center text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  onClick={(e) => handleCheckout(e, tier.id)}>
                                        Buy Now - Save 40%
                  </button> */}
                  {tier.id === '1' ? (
                    <button 
                      className="mt-6 block rounded-md bg-indigo-600 px-3.5 py-2 text-center text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                      onClick={(e) => handleCheckout(e, tier.id)}
                    >
                      Buy Now - Save 40%
                    </button>
                  ) : (
                    <div className="mt-6 rounded-md bg-gray-100 px-3.5 py-4 text-center">
                      <p className="text-sm font-medium text-gray-700">
                      📚 Turn your digital book into print after creation
                      </p>
                    </div>
                  )}
                </div>
              ))}
              
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}



